import React from "react";
import { Navigate, Route } from "react-router-dom";
import { LOGISTICS_ROLES } from "../constants/roles";
import AppShell from "../layout/AppShell";
import RequireRoles from "../layout/RequireRoles";
import { LOGISTICS_NAV } from "./nav-config";
import LogisticsDeliveryQueuePage from "./pages/delivery-queue";
import LogisticsCodWatchPage from "./pages/cod-watch";
import LogisticsOrdersPage from "./pages/orders";
// Users + User Details — the legacy /users and /user/:id screens, mounted unchanged in
// every console. The users table links to `<current path>/:id`, so a row click stays in
// this console instead of jumping to the legacy /user/:id route.
import { Users } from "../../pages/users";
import UserDetails from "../../pages/user-details";
// GLP-1 Dashboard — the legacy /glp1-dashboard page, mounted unchanged.
// API: GET /glp1Dashboard/admin/orders (+ POST /delivery/markDelivered/:id from its rows).
import GLP1Dashboard from "../../pages/glp1-dashboard";
// Order Tracking Sheet — the legacy /order-tracking-sheet page, mounted unchanged. Its API
// (pillup-api routes/api/ops/trackingSheet.js TRACKING_SHEET_ROLES) already grants every
// role this console admits.
import OrderTrackingSheet from "../../pages/order-tracking-sheet";

// Logistics Console — a top-level console at /v2/logistics/*, sibling of /v2/ops,
// /v2/pharmacy and /v2/finance.
//
// This is a RESTYLE of the legacy /delivery page, not a replacement: it reads the same
// endpoint and fires the same action APIs. The legacy page stays live and untouched.
//
// Delivery Queue is the landing view — it is the operators' work queue, and COD Watch is a
// narrower lens on the same rows.
export const LOGISTICS_ROUTES = (
    <Route path="/v2/logistics" element={<AppShell nav={LOGISTICS_NAV} />}>
        <Route index element={<Navigate to="deliveries" replace />} />
        <Route
            path="orders"
            element={
                <RequireRoles roles={LOGISTICS_ROLES}>
                    <LogisticsOrdersPage />
                </RequireRoles>
            }
        />
        <Route
            path="deliveries"
            element={
                <RequireRoles roles={LOGISTICS_ROLES}>
                    <LogisticsDeliveryQueuePage />
                </RequireRoles>
            }
        />
        <Route
            path="cod"
            element={
                <RequireRoles roles={LOGISTICS_ROLES}>
                    <LogisticsCodWatchPage />
                </RequireRoles>
            }
        />
        <Route
            path="tracking-sheet"
            element={
                <RequireRoles roles={LOGISTICS_ROLES}>
                    <OrderTrackingSheet />
                </RequireRoles>
            }
        />
        <Route
            path="glp1"
            element={
                <RequireRoles roles={LOGISTICS_ROLES}>
                    <GLP1Dashboard />
                </RequireRoles>
            }
        />
        <Route
            path="users"
            element={
                <RequireRoles roles={LOGISTICS_ROLES}>
                    <Users />
                </RequireRoles>
            }
        />
        <Route
            path="users/:id"
            element={
                <RequireRoles roles={LOGISTICS_ROLES}>
                    <UserDetails />
                </RequireRoles>
            }
        />
    </Route>
);
